// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"b8dff886","329":"a42ed45f","535":"d15383e2","888":"b03fd1c9","922":"56a434c8","991":"f7a49101"}[chunkId] + ".chunk.css";
};